export default __webpack_public_path__ + "static/media/seven.8a5e7be3.glb";